import { Link, useParams } from "react-router-dom";

export const ButtonUserBookFirstEpisode = ({ episodeId, isEpisodeListPage }) => {
    const { school } = useParams();
    if (!episodeId) return;
    if (!isEpisodeListPage) return;
    return <Link className="btn" to={`/${school}/userbook/episode/view/${episodeId}`}><i className="fas fa-book"></i> 첫회보기</Link>;
}